import React from 'react';

function LogTableRow(props) {
  return <tr className={props.className}>{props.children}</tr>;
}

export default LogTableRow;
